"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUpperLimit = void 0;
const is_product_1 = require("../../functions/is-product/is-product");
/**
 * Determines if a product is upper limit energy.
 * @param product
 */
function isUpperLimit(product) {
    return (0, is_product_1.isAFrrPlus)(product) || (0, is_product_1.isMFrrPlus)(product);
}
exports.isUpperLimit = isUpperLimit;
